import { Link } from "react-router-dom";
import { Crown, Sparkles } from "lucide-react";
import { PRO_PRICING } from "@/constants/pro-features";

export function ProUpgradeStrip() {
  return (
    <div className="border-b border-brand/20 bg-gradient-to-r from-brand/10 via-surface-elevated to-focus/5">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-2.5 sm:px-6 lg:px-8">
        <div className="flex min-w-0 items-center gap-2 text-sm text-white/80">
          <Sparkles className="h-4 w-4 shrink-0 text-brand" />
          <span>
            <span className="font-semibold text-white">BurnChart Pro</span>
            <span className="hidden text-white/65 sm:inline">
              {" "}
              — AI advisor, multiple startups, business plans & API from $
              {PRO_PRICING.monthlyUsd}/mo
            </span>
          </span>
        </div>
        <Link
          to="/settings/billing"
          className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-brand px-3.5 py-1.5 text-xs font-bold text-surface transition-colors hover:bg-brand-muted"
        >
          <Crown className="h-3.5 w-3.5" />
          View plans
        </Link>
      </div>
    </div>
  );
}
